import React from "react"
import { Trans } from "react-i18next"
import DivContentLoader from "../../Component/DivContentLoader"

const KOLWorkLoading = () => {
  return (
    <div className="w-full md:pt-2 md:p-2 pt-8 ">
      <section className="my-4 h-full">
        <h2 className="text-2xl text-left font-medium m-2 text-red-default">
          <Trans>KOLProfile.service-plan</Trans>
        </h2>
        <div className="carousel carousel-center max-w-full px-4 space-x-4 rounded-box overflow-x-auto">
          <span className="carousel-item py-4 relative w-full flex justify-center">
            <DivContentLoader w={280} h={400} r={20} />
          </span>
        </div>
      </section>

      <section className="my-4">
        <h2 className="text-2xl text-left font-medium m-2 text-red-default ">
          <Trans>KOLProfile.case-study</Trans>
        </h2>
        <div className="carousel carousel-center max-w-full px-4 space-x-4 rounded-box overflow-x-auto">
          <span className="carousel-item py-4 relative w-full flex justify-center">
            <DivContentLoader w={280} h={480} r={20} />
          </span>
        </div>
      </section>
    </div>
  )
}

export default KOLWorkLoading
